export const GET_USER_REQUEST = "GET_USER_REQUEST"
export const GET_USER_SUCCESS = "GET_USER_SUCCESS"
export const GET_USER_FAIL = "GET_USER_FAIL" 

export const GET_ALL_USER_REQUEST = "GET_ALL_USER_REQUEST"
export const GET_ALL_USER_SUCCESS = "GET_ALL_USER_SUCCESS"
export const GET_ALL_USER_FAIL = "GET_ALL_USER_FAIL" 

export const CREATE_USER_BY_PHONE_REQUEST = "CREATE_USER_BY_PHONE_REQUEST"
export const CREATE_USER_BY_PHONE_SUCCESS = "CREATE_USER_BY_PHONE_SUCCESS"
export const CREATE_USER_BY_PHONE_FAIL = "CREATE_USER_BY_PHONE_FAIL"

export const CREATE_USER_BY_EMAIL_REQUEST = "CREATE_USER_BY_EMAIL_REQUEST"
export const CREATE_USER_BY_EMAIL_SUCCESS = "CREATE_USER_BY_EMAIL_SUCCESS"
export const CREATE_USER_BY_EMAIL_FAIL = "CREATE_USER_BY_EMAIL_FAIL"

export const GET_USER_LOGS_REQUEST = "GET_USER_LOGS_REQUEST"
export const GET_USER_LOGS_SUCCESS = "GET_USER_LOGS_SUCCESS"
export const GET_USER_LOGS_FAIL = "GET_USER_LOGS_FAIL" 

export const GET_USER_LOGS_COUNT_REQUEST = "GET_USER_LOGS_COUNT_REQUEST"
export const GET_USER_LOGS_COUNT_SUCCESS = "GET_USER_LOGS_COUNT_SUCCESS"
export const GET_USER_LOGS_COUNT_FAIL = "GET_USER_LOGS_COUNT_FAIL" 

export const CREATE_USER_LOGS_REQUEST = "CREATE_USER_LOGS_REQUEST"
export const CREATE_USER_LOGS_SUCCESS = "CREATE_USER_LOGS_SUCCESS"
export const CREATE_USER_LOGS_FAIL = "CREATE_USER_LOGS_FAIL"

export const LOGIN_WITH_PHONE_REQUEST = "LOGIN_WITH_PHONE_REQUEST"
export const LOGIN_WITH_PHONE_SUCCESS = "LOGIN_WITH_PHONE_SUCCESS"
export const LOGIN_WITH_PHONE_FAIL = "LOGIN_WITH_PHONE_FAIL"


export const SAVING_ACCESS_KEY_REQUEST = "SAVING_ACCESS_KEY_REQUEST"
export const SAVING_ACCESS_KEY_SUCCESS = "SAVING_ACCESS_KEY_SUCCESS"
export const SAVING_ACCESS_KEY_FAIL = "SAVING_ACCESS_KEY_FAIL"


export const GET_ADMIN_NAME_REQUEST = "GET_ADMIN_NAME_REQUEST"
export const GET_ADMIN_NAME_SUCCESS = "GET_ADMIN_NAME_SUCCESS"
export const GET_ADMIN_NAME_FAIL = 'GET_ADMIN_NAME_FAIL'

export const CHANGE_ADMIN_USERNAME = 'CHANGE_ADMIN_USERNAME'
export const CHANGE_ADMIN_USERNAME_SUCCESS = 'CHANGE_ADMIN_USERNAME_SUCCESS'
export const CHANGE_ADMIN_USERNAME_FAIL = 'CHANGE_ADMIN_USERNAME_FAIL'

export const CHANGE_ADMIN_PASSWORD = 'CHANGE_ADMIN_PASSWORD'
export const CHANGE_ADMIN_PASSWORD_SUCCESS = 'CHANGE_ADMIN_PASSWORD_SUCCESS'
export const CHANGE_ADMIN_PASSWORD_FAIL = 'CHANGE_ADMIN_PASSWORD_FAIL'


export const CREATE_ADMIN_ACCOUNT = 'CREATE_ADMIN_ACCOUNT'
export const CREATE_ADMIN_ACCOUNT_SUCCESS = 'CREATE_ADMIN_ACCOUNT_SUCCESS'
export const CREATE_ADMIN_ACCOUNT_FAIL = 'CREATE_ADMIN_ACCOUNT_FAIL'